import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { CenteringDiv, FlexRowDiv, H1, P } from 'components/generic/HomePageComponents'
import { CareguideButton } from './Styled'

const CareGuide = ({ careguideImageUrl, careguideDescription, careguideHeader }) => (
  <FlexRowDiv bg='grey'>
    <CenteringDiv justifyContent='center'>
      <GenericLazyLoadImage src={careguideImageUrl} width={['320px', '350px', '450px']} pt='50px' />
      <H1 m='0' fontSize={['35px', '40px', '40px']} mt='20px'>
        {careguideHeader}
      </H1>
      <FlexRowDiv>
        <P
          m='0'
          fontSize='24px'
          textAlign={['center']}
          pt='20px'
          fontWeight='400'
          maxWidth='none'
          pb='20px'
        >
          {careguideDescription}
        </P>
      </FlexRowDiv>
      <CareguideButton href='/about'>Learn More</CareguideButton>
    </CenteringDiv>
  </FlexRowDiv>
)

export default CareGuide
